export const FETCH_SUGGESTIONS_SUCCEEDED = "FETCH_SUGGESTIONS_SUCCEEDED";
export const CLEAR_SUGGESTIONS = "CLEAR_SUGGESTIONS";

export const SEARCH_ROUTE_STARTED = "SEARCH_ROUTE_STARTED";
export const SEARCH_ROUTE_SUCCEEDED = "SEARCH_ROUTE_SUCCEEDED";

export const SEARCH_ROUTE_FAILED = "SEARCH_ROUTE_FAILED";

export const SET_ROUTE_SEARCH_PARAMS = "SET_ROUTE_SEARCH_PARAMS";
export const FETCH_COMMON_STATS_SUCCEEDED = "FETCH_COMMON_STATS_SUCCEEDED";
export const TOGGLE_LEGEND_POPUP = "TOGGLE_LEGEND_POPUP";
export const FETCH_COMMON_STATS_FAILED = "FETCH_COMMON_STATS_FAILED";

export const CHANGE_ROUTE = "CHANGE_ROUTE";
export const ROUTE_NOT_FOUND = "ROUTE_NOT_FOUND";
export const ROUTE_WITHOUT_RESTRICTIONS = "ROUTE_WITHOUT_RESTRICTIONS";
export const SHOW_RESULTS = "SHOW_RESULTS";

export const TOGGLE_SHOW_PASSING_CITIES = "TOGGLE_SHOW_PASSING_CITIES";

export const UPDATE_EXCLUDED_CITIES = "UPDATE_EXCLUDED_CITIES";
export const ADD_EXCLUDED_CITY = "ADD_EXCLUDED_CITY";
export const REMOVE_EXCLUDED_CITY = "REMOVE_EXCLUDED_CITY";

export const UPDATE_EXCLUDED_COUNTRIES = "UPDATE_EXCLUDED_COUNTRIES";
export const ADD_EXCLUDED_COUNTRY = "ADD_EXCLUDED_COUNTRY";
export const REMOVE_EXCLUDED_COUNTRY = "REMOVE_EXCLUDED_COUNTRY";
export const UPDATE_ROUTE_REQUEST = "UPDATE_ROUTE_REQUEST";
export const RESET_ALL_EXCLUDED = "RESET_ALL_EXCLUDED";

/* query string sync */
export const SET_RESTRICTION_INITIAL_VALUE = "SET_RESTRICTION_INITIAL_VALUE";

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";

export const SET_SHOW_LIGHT_VERSION = "SET_SHOW_LIGHT_VERSION";

export const HIDE_ERROR_NOTIFICATION = "HIDE_ERROR_NOTIFICATION";
export const SET_APP_INITIALIZED = "SET_APP_INITIALIZED";

export const INC_PENDING_REQUESTS = "INC_PENDING_REQUESTS";
export const DEC_PENDING_REQUESTS = "DEC_PENDING_REQUESTS";
export const CALCULATE_ROUTE_METRICS = "CALCULATE_ROUTE_METRICS";
export const SAVE_PLATON_RATE = "SAVE_PLATON_RATE";
export const SET_USER_PROFILE = "SET_USER_PROFILE";
